// extracted by mini-css-extract-plugin
module.exports = {"carousel":"i_T5","dots":"i_T6","button":"i_T7","story-slick-arrow":"i_T8","prev":"i_T9","next":"i_UA"};